<template>
    <div class="item-row">
        <div class="label-cell">
            <router-link
                class="label"
                :to="{ name: 'professional-skill', params: { id: item.id }}"
                :title="item.name"
            >
                {{ item.name }}
            </router-link>
        </div>

        <div class="option-cell">
            <Bullet
                class="bullet"
                positive
                v-loading.small.full="loading"
                :value="item.userAcknowledgment"
                @change="changeHandler(item, $event)"
            />
        </div>
        <div class="option-cell">
            <Bullet
                class="bullet"
                :positive="false"
                v-loading.small.full="loading"
                :value="item.userAcknowledgment"
                @change="changeHandler(item, $event)"
            />
        </div>
    </div>
</template>

<script>
import Bullet from "./Bullet";
import { mapActions } from 'vuex';

const trackActions = [
    'setCompetenceAcknowledge',
];

export default {
    name: "HardCompetenceItem",

    components: {
        Bullet,
    },

    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        ...mapActions('accountTrack', trackActions),

        async changeHandler(item, evt) {
            this.loading = true;
            await this.setCompetenceAcknowledge({
                competenceId: this.item.id,
                status: evt,
            });
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.item-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
}

.label-cell, .option-cell {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 40px;

    @include on-xs {
        height: 64px;
    }
}

.label-cell {
    flex: 1 1 70%;
    min-width: 0;
    padding: 0 32px 0 0;
    white-space: nowrap;

    @include on-xs {
        flex: 1 1 50%;
    }
}

.label {
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #4663AB;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @include on-xs {
        white-space: normal;
        max-height: 48px;
    }
}

.option-cell {
    flex: 0 0 15%;
    text-align: center;
    position: relative;
    justify-content: center;

    @include on-xs {
        flex: 0 0 25%;
    }

    &::after {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        left: 50%;
        width: 1px;
        height: 100%;
        background-color: #E3E9F0;
    }
}

.bullet {
    z-index: 1;
}
</style>
